export class RmZonesIdRequest{
    zoneId:number;
    rackId:number;
    plantId?:number;
    constructor(zoneId:number,rackId:number,plantId?:number){
        this.zoneId = zoneId;
        this.rackId = rackId;
        this.plantId = plantId;
    }
}